/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){
    $('.image-zoom').zoom();
  });
 $(document).ready(function() {
    $("#Content_tab").hide();
   $(".tabs li").on("click",function(){
     $("#Content_tab").slideToggle("slow");
     
     return false;
   })
  });

$(".Form__Submit").on("click",function(){
//   e.preventDefault();
var name=$("#name").val();
  var last_name=$("#last_name").val();
  var email=$("#email").val();
  var number=$("#number").val();
  var company=$("#company").val();
  var address=$("#address").val();
  var address2=$("#address2").val();
  var city=$("#city").val();
  var country =$("#address_country_new").val();
  var state= $("#address_province_new").val();
  var zip=$("#zip").val();
  var resale_number=$("#resale_number").val();
  var website_url=$("#website_url").val();
  var tax_id=$("#tax_id").val();
  var location=$("#location").val();
  var brands=$("#brands").val();
  var store_image1=$("#upload").val();
  var store_image2=$("#upload2").val();
  var store_image3=$("#upload3").val();
  var num_val = $.isNumeric(number);
  
  if(name ==""){
   $("#name").addClass("error");
  }else{
  $("#name").removeClass("error");
  }
  
  if(last_name ==""){
    $("#last_name").addClass("error");
  }
  else{
  $("#last_name").removeClass("error");
  }
  if(number ==""){
    $("#number").addClass("error");
  }else if(!num_val){
   $("#number").addClass("error");
  }
  else{
  $("#number").removeClass("error");
  }
  if(email ==""){
    $("#email").addClass("error");
  }else{
  $("#email").removeClass("error");
  }
  if(company ==""){
    $("#company").addClass("error");
  }else{
  $("#company").removeClass("error");
  }
  if(city ==""){
    $("#city").addClass("error");
  }else{
  $("#city").removeClass("error");
  }
  if(address ==""){
    $("#address").addClass("error");
  }else{
  $("#name").removeClass("error");
  }
  if(state ==""){
    $("#state").addClass("error");
  }else{
  $("#state").removeClass("error");
  }
  if(zip ==""){
    $("#zip").addClass("error");
  }else{
  $("#zip").removeClass("error");
  }
  if(tax_id ==""){
    $("#tax_id").addClass("error");
  }else{
  $("#tax_id").removeClass("error");
  }
  if(resale_number ==""){
   $("#resale_number").addClass("error");
  }else{
  $("#resale_number").removeClass("error");
  }
  if(website_url ==""){
   $("#website_url").addClass("error");
  }else{
  $("#website_url").removeClass("error");
  }
  if(location ==""){
    $("#location").addClass("error");
  }else{
  $("#location").removeClass("error");
  }
  if(brands ==""){
    $("#brands").addClass("error");
  }else{
  $("#brands").removeClass("error");
  }
  if(store_image1 ==""){
   $("#store_image1").addClass("error");
  }else{
  $("#store_image1").removeClass("error");
  }
  if(store_image2 ==""){
    $("#store_image2").addClass("error");
  }else{
  $("#store_image2").removeClass("error");
  }
  if(store_image3 ==""){
    $("#store_image3").addClass("error");
  }else{
  $("#store_image3").removeClass("error");
  }


})

$(".sponsorship .Form__Submit").on("click",function(){
//   e.preventDefault();
var name=$("#name").val();
  var last_name=$("#last_name").val();
  var email=$("#email").val();
  var number=$("#number").val();
  var company=$("#company").val();
  var title=$("#title").val();
  var requsted=$("#requsted").val();
  var additional=$("#city").val();
  var website_url=$("#website_url").val();
  
  
  if(name ==""){
   $("#name").addClass("error");
  }else{
  $("#name").removeClass("error");
  }
  
  if(last_name ==""){
    $("#last_name").addClass("error");
  }
  else{
  $("#last_name").removeClass("error");
  }
  if(number ==""){
    $("#number").addClass("error");
  }else if(!num_val){
   $("#number").addClass("error");
  }
  else{
  $("#number").removeClass("error");
  }
  if(email ==""){
    $("#email").addClass("error");
  }else{
  $("#email").removeClass("error");
  }
  if(company ==""){
    $("#company").addClass("error");
  }else{
  $("#company").removeClass("error");
  }
  if(title ==""){
    $("#title").addClass("error");
  }else{
  $("#title").removeClass("error");
  }
  if(requsted ==""){
    $("#requsted").addClass("error");
  }else{
  $("#requsted").removeClass("error");
  }
  if(additional ==""){
    $("#additional").addClass("error");
  }else{
  $("#additional").removeClass("error");
  }
  
  if(website_url ==""){
   $("#website_url").addClass("error");
  }else{
  $("#website_url").removeClass("error");
  }
  
})



